<style>
  .ivu-radio-group {
    display: block;
    margin-bottom: 10px;
  }
  
  .ivu-form-item {
    margin-bottom: 15px;
  }
  .ivu-table-cell{
    padding: 0 4px !important;
  }
  </style>
  <template>
    <Layout>
      <Content>
        <Card :style="{ 'padding': '0px 5px', 'margin-bottom': '5px' }">
          <span class="search_span_width">
            <span class="search_span_width_part1">ID：</span>
            <Input v-model="search.id" placeholder="ID" clearable :style="{ 'width': '80px' }"></Input>
          </span>
          <span class="search_span_width">
            <span class="search_span_width_part1">&nbsp;&nbsp;注册类型：</span>
            <Select v-model="search.account_type" style="width:130px">
              <Option :value="-1">全部</Option>
              <Option :value="2">有戏</Option>
			  <Option :value="5">chatcar</Option>
              <Option :value="0">风平</Option>
            </Select>
          </span>
          <span class="search_span_width">
            <span class="search_span_width_part1">手机号：</span>
            <Input v-model="search.mobile" placeholder="请输入手机号" clearable :style="{ 'width': '110px' }"></Input>
          </span>
          <span class="search_span_width_part1">
            <span class="search_span_width_part1">&nbsp;&nbsp;所属代理商：</span>
            <Select v-model="search.agent_id" placeholder="请输入代理商名称" filterable clearable :style="{ 'width': '150px' }">
              <Option :value="-1" :key="-1">无绑定代理商</Option>
              <Option v-for="(option, index) in agent_list" :value="option.id" :key="index">{{ option.agent_name }}</Option>
            </Select>
          </span>
          <span class="search_span_width">
            <span class="search_span_width_part1">&nbsp;&nbsp;用户名：</span>
            <Input v-model="search.nickname" placeholder="请输入用户名" clearable :style="{ 'width': '110px' }"></Input>
          </span>
          <span class="search_span_width">
            <span class="search_span_width_part1">&nbsp;&nbsp;渠道：</span>
            <Select v-model="search.channel" clearable style="width:130px">
              <Option v-for="(item, index) in channel_list" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </span>
		  <span class="search_span_width">
		    <span class="search_span_width_part1">&nbsp;&nbsp;用户类型：</span>
		    <Select v-model="search.user_type" style="width:130px">
		      <Option :value="0">全部</Option>
		      <Option :value="1">推广大使</Option>
		      <Option :value="5">城市服务商</Option>
			  <Option :value="10">合伙人</Option>
		    </Select>
		  </span>
          <br /><br />
          <span class="search_span_width">
            <span class="search_span_width_part1">客户端会员等级：</span>
            <Select v-model="search.rights_level" style="width:130px" clearable>
              <!-- <Option value="0">请选择</Option> -->
              <Option v-for="item in user_level" :key="item.id" :value="item.id">{{ item.name }}</Option>
            </Select>
          </span>
          <span class="search_span_width">
            <span class="search_span_width_part1">&nbsp;&nbsp;小程序会员等级：</span>
            <Select v-model="search.applet_rights_level" style="width:130px" clearable>
              <!-- <Option value="0">请选择</Option> -->
              <Option v-for="item in user_applet_level" :key="item.id" :value="item.id">{{ item.name }}</Option>
            </Select>
          </span>
          <span class="search_span_width">
            <span class="search_span_width_part1">&nbsp;&nbsp;有戏会员等级：</span>
            <Select v-model="search.playlet_member_level" style="width:130px" clearable>
              <!-- <Option value="0">请选择</Option> -->
              <Option v-for="item in user_playlet_level" :key="item.id" :value="item.id">{{ item.name }}</Option>
            </Select>
          </span>
          <span class="search_span_width">
            <span class="search_span_width_part1">&nbsp;&nbsp;邀请人：</span>
            <Input v-model="search.inviter" placeholder="请输入手机号" clearable :style="{ 'width': '110px' }"></Input>
          </span>
          <Button type='primary' icon="ios-search" :style="{ 'margin-left': '20px' }" @click="getUserList(1)">搜索</Button>
        </Card>
        <Card>
          <p :style="{ 'margin': '5px 10px 10px 20px', 'clear': 'both', 'overflow': 'hidden' }">
            <span :style="{ 'text-align': 'center', 'float': 'left' }">
              <Button type='primary' :style="{ 'margin-left': '5px' }" @click="addUserModal()">添加会员</Button>
            </span>
          </p>
          <Card id="tableContent">
            <Table :columns="tableColumns" :data="user_list"></Table>
            <Page :total="recordTotal" :current="page" :page-size="15" :show-elevator="true" @on-change="getUserList" />
          </Card>
        </Card>
      </Content>
      <Modal v-model="showmodal" :footer-hide="true" title="开通会员">
        <Form ref="rights" :model="rights" :label-width="80" :rules="memberVip">
          <FormItem label="会员等级" prop="rights_level">
            <Select v-model="rights.rights_level" style="width:160px" @on-change="computeTime($event, 0)">
              <Option value="0">请选择</Option>
              <Option v-for="item in user_level" :key="item.id" :value="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="有效期" prop="period">
            <Select v-model="period" @on-change="changePeriodTime($event, 0)" style="width:160px">
              <Option v-for="(item, index) in period_list" :value="item.val" :key="index">{{ item.label }}</Option>
            </Select>
            <span>已下面开始结束时间为准</span>
          </FormItem>
          <FormItem label="权限">
            <CheckboxGroup v-model="rights.rights">
              <Checkbox label="video">视频</Checkbox>
              <Checkbox label="live">直播</Checkbox>
              <Checkbox label="rank">排行榜</Checkbox>
              <Checkbox label="script">脚本库</Checkbox>
              <Checkbox label="knowledge">知识库</Checkbox>
              <Checkbox label="aicreation">AI创作</Checkbox>
              <Checkbox label="aivideo">智能成片</Checkbox>
              <Checkbox label="watermark">视频水印</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="开始时间">
            <Row>
              <Col span="11">
              <FormItem prop="start_time">
                <DatePicker type="date" :value="rights.start_time" @on-change="computePeriod($event, 0)"
                  format="yyyy-MM-dd" placeholder="有效期" style="width: 300px"></DatePicker>
              </FormItem>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="结束时间">
            <Row>
              <Col span="11">
              <FormItem prop="end_time">
                <DatePicker type="date" :value="rights.end_time" format="yyyy-MM-dd" placeholder="有效期"
                  style="width: 300px"></DatePicker>
              </FormItem>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Button @click="closeModal" style="margin-left: 8px">取消</Button>&nbsp;&nbsp;&nbsp;&nbsp;
            <Button type="primary" @click="updateRights(0)">提交</Button>
          </FormItem>
        </Form>
      </Modal>
      <Modal v-model="showApplet" :footer-hide="true" title="开通会员">
        <Form ref="rights" :model="rights" :label-width="80" :rules="appletMemberVip">
          <FormItem label="会员等级" prop="applet_rights_level">
            <Select v-model="rights.applet_rights_level" style="width:160px" @on-change="computeTime($event, 1)">
              <Option value="0">请选择</Option>
              <Option v-for="item in user_applet_level" :key="item.id" :value="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="有效期" prop="applet_period">
            <Select v-model="applet_period" @on-change="changePeriodTime($event, 1)" style="width:160px">
              <Option v-for="(item, index) in applet_period_list" :value="item.val" :key="index">{{ item.label }}</Option>
            </Select>
            <span>已下面开始结束时间为准</span>
          </FormItem>
          <FormItem label="权限">
            <CheckboxGroup v-model="rights.rights">
              <Checkbox label="video">视频</Checkbox>
              <Checkbox label="live">直播</Checkbox>
              <Checkbox label="rank">排行榜</Checkbox>
              <Checkbox label="script">脚本库</Checkbox>
              <Checkbox label="knowledge">知识库</Checkbox>
              <Checkbox label="aicreation">AI创作</Checkbox>
              <Checkbox label="aivideo">智能成片</Checkbox>
              <Checkbox label="watermark">视频水印</Checkbox>
            </CheckboxGroup>
          </FormItem>
          <FormItem label="开始时间">
            <Row>
              <Col span="11">
              <FormItem prop="applet_start_time">
                <DatePicker type="date" :value="rights.applet_start_time" @on-change="computePeriod($event, 1)"
                  format="yyyy-MM-dd" placeholder="有效期" style="width: 300px"></DatePicker>
              </FormItem>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="结束时间">
            <Row>
              <Col span="11">
              <FormItem prop="applet_end_time">
                <DatePicker type="date" :value="rights.applet_end_time" disabled format="yyyy-MM-dd" placeholder="有效期"
                  style="width: 300px"></DatePicker>
              </FormItem>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Button @click="closeModal" style="margin-left: 8px">取消</Button>&nbsp;&nbsp;&nbsp;&nbsp;
            <Button type="primary" @click="updateRights(1)">提交</Button>
          </FormItem>
        </Form>
      </Modal>
      <!-- 短剧会员权限配置 -->
      <Modal v-model="showPlaylet" :footer-hide="true" title="开通会员">
        <Form ref="rights" :model="rights" :label-width="80" :rules="playletMemberVip">
          <FormItem label="会员等级" prop="playlet_level">
            <Select v-model="rights.playlet_level" style="width:160px" @on-change="computeTime($event, 2)">
              <Option value="0">请选择</Option>
              <Option v-for="item in user_playlet_level" :key="item.id" :value="item.id">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="有效期" prop="playlet_period">
            <Select v-model="playlet_period" @on-change="changePeriodTime($event, 2)" style="width:160px">
              <Option v-for="(item, index) in playlet_period_list" :value="item.val" :key="index">{{ item.label }}</Option>
            </Select>
            <span>已下面开始结束时间为准</span>
          </FormItem>
          <FormItem label="开始时间" prop="playlet_start_time">
            <Row>
              <Col span="11">
              <FormItem prop="playlet_start_time">
                <DatePicker type="date" :value="rights.playlet_start_time"
                  @on-change="computePeriod($event, 2)" format="yyyy-MM-dd" placeholder="开始时间"
                  style="width: 300px"></DatePicker>
              </FormItem>
              </Col>
            </Row>
          </FormItem>
          <FormItem label="结束时间" prop="playlet_end_time">
            <Row>
              <Col span="11">
              <FormItem prop="playlet_end_time">
                <DatePicker type="date" :value="rights.playlet_end_time" disabled
                  format="yyyy-MM-dd" placeholder="结束时间" style="width: 300px"></DatePicker>
              </FormItem>
              </Col>
            </Row>
          </FormItem>
          <FormItem>
            <Button @click="closeModal" style="margin-left: 8px">取消</Button>&nbsp;&nbsp;&nbsp;&nbsp;
            <Button type="primary" @click="updateRights(2)">提交</Button>
          </FormItem>
        </Form>
      </Modal>
      <Modal v-model="showRecharge" :footer-hide="true" title="增值权益">
        <Form ref="rights" :model="rights" :label-width="120">
          <FormItem label="实时驱动" prop="real_type">
            <Row>
              <FormItem prop="real_times">
                <DatePicker type="daterange" v-model="rights.real_time" split-panels format="yyyy年MM月dd日"
                  placeholder="请选择有效期" style="width: 200px"></DatePicker>
                <Button-group>
                  &nbsp;<Button type="warning">{{ rights.real_time_start }} / {{ rights.real_time_end }}</Button>
                </Button-group>
              </FormItem>
            </Row>
          </FormItem>
          <FormItem label="算力" prop="recharge_computility">
            <Input v-model="rights.recharge_computility" placeholder="输入需要充的算力" style="width: 250px">
            </Input>
            <Button-group>
              <Button type="success">已用{{ rights.computility_consume }}</Button>
              <Button type="warning">剩余{{ rights.computility }}</Button>
            </Button-group>
          </FormItem>
          <FormItem label="充值时长" prop="recharge_time">
            <Input v-model="rights.recharge_time" placeholder="输入需要充的时长" style="width: 250px">
            <span slot="append">秒</span>
            </Input>
            <Button-group>
              <Button type="info">总时长{{ rights.video_duration }}秒</Button>
              <Button type="success">已用{{ rights.use_duration }}秒</Button>
              <Button type="warning">剩余{{ rights.leave_duration | toFixed(2) }}秒</Button>
            </Button-group>
          </FormItem>
          <FormItem label="Ai创作次数" prop="creative_time_num">
            <Input v-model="rights.creative_time_num" placeholder="输入Ai创作次数" style="width: 200px" />
            <Button-group>
              &nbsp;<Button type="warning">剩余{{ rights.creative_time }}次</Button>
            </Button-group>
          </FormItem>
          <FormItem label="数字分身次数" prop="role_number_recharge">
            <Input v-model="rights.role_number_recharge" placeholder="请输入次数" style="width: 200px" />
            <Button-group>
              &nbsp;<Button type="warning">剩余{{ rights.role_number }}次</Button>
            </Button-group>
          </FormItem>
          <FormItem label="声音克隆(标准)" prop="clone_voice_number_add">
            <Input v-model="rights.clone_voice_number_add" placeholder="请输入次数" style="width: 200px" />
            <Button-group>
              &nbsp;<Button type="warning">剩余{{ rights.clone_voice_number }}次</Button>
            </Button-group>
          </FormItem>
          <FormItem label="声音克隆(高品质)" prop="high_quality_voice_num_add">
            <Input v-model="rights.high_quality_voice_num_add" placeholder="请输入次数" style="width: 200px" />
            <Button-group>
              &nbsp;<Button type="warning">剩余{{ rights.high_quality_voice_num }}次</Button>
            </Button-group>
          </FormItem>
          <FormItem label="AI对话次数" prop="talk_number_recharge">
            <Input v-model="rights.talk_number_add" placeholder="请输入次数" style="width: 200px" />
            <Button-group>
              &nbsp;<Button type="warning">剩余{{ rights.talk_number }}次</Button>
            </Button-group>
          </FormItem>
          <FormItem label="问答对回复次数" prop="talk_qanumber">
            <Input v-model="rights.talk_qanumber_add" placeholder="请输入次数" style="width: 200px" />
            <Button-group>
              &nbsp;<Button type="warning">剩余{{ rights.talk_qanumber }}次</Button>
            </Button-group>
          </FormItem>
          <FormItem label="形象克隆(标准)" prop="quality_appearance_num">
            <Input v-model="rights.quality_appearance_num_add" placeholder="请输入次数" style="width: 200px" />
            <Button-group>
              &nbsp;<Button type="warning">剩余{{ rights.quality_appearance_num }}次</Button>
            </Button-group>
          </FormItem>
          <FormItem label="形象克隆(极速)" prop="speedy_quality_appearance_num">
            <Input v-model="rights.speedy_quality_appearance_num_add" placeholder="请输入次数" style="width: 200px" />
            <Button-group>
              &nbsp;<Button type="warning">剩余{{ rights.speedy_quality_appearance_num }}次</Button>
            </Button-group>
          </FormItem>
          <FormItem label="形象克隆(灵动)" prop="figure_lingdong_num">
            <Input v-model="rights.figure_lingdong_num_add" placeholder="请输入次数" style="width: 200px" />
            <Button-group>
              &nbsp;<Button type="warning">剩余{{ rights.figure_lingdong_num }}次</Button>
            </Button-group>
          </FormItem>
          <FormItem label="形象克隆(高品质)" prop="high_quality_appearance_num">
            <Input v-model="rights.high_quality_appearance_num_add" placeholder="请输入次数" style="width: 200px" />
            <Button-group>
              &nbsp;<Button type="warning">剩余{{ rights.high_quality_appearance_num }}次</Button>
            </Button-group>
          </FormItem>
          <FormItem label="形象克隆(照片)" prop="photo_quality_appearance_num">
            <Input v-model="rights.photo_quality_appearance_num_add" placeholder="请输入次数" style="width: 200px" />
            <Button-group>
              &nbsp;<Button type="warning">剩余{{ rights.photo_quality_appearance_num }}次</Button>
            </Button-group>
          </FormItem>
          <FormItem label="形象克隆(4K)" prop="super_quality_appearance_num">
            <Input v-model="rights.super_quality_appearance_num_add" placeholder="请输入次数" style="width: 200px" />
            <Button-group>
              &nbsp;<Button type="warning">剩余{{ rights.super_quality_appearance_num }}次</Button>
            </Button-group>
          </FormItem>
          <FormItem>
            <Button @click="closeModal" style="margin-left: 8px">取消</Button>&nbsp;&nbsp;&nbsp;&nbsp;
            <Button type="primary" @click="updateRecharge()">提交</Button>
          </FormItem>
        </Form>
      </Modal>
      <Modal v-model="showUserModal" :footer-hide=true title="用户信息">
        <Form ref="user" :model="user" :label-width="80" :rules="userRule">
          <FormItem label="渠道" prop="channel">
            <Select v-model="user.channel" style="width:160px">
              <Option value="0">请选择</Option>
              <Option v-for="(item, index) in channel_list" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
          <FormItem label="用户类型" prop="account_type">
            <Select v-model="user.account_type" style="width:160px">
              <Option :value='0'>风平</Option>
              <Option :value='2'>有戏</Option>
			  <Option :value='5'>charcar</Option>
            </Select>
          </FormItem>
          <!-- 		<FormItem label="生成分组" prop="channel">
          <Select v-model="user.video_group" style="width:160px">
            <Option v-for="(item,index) in video_group" :value="item.group_id" :key="index">{{ item.group_name }}</Option>
          </Select>
        </FormItem> -->
  
          <FormItem label="所属代理商" prop="agent_id">
            <Select v-model="user.agent_id" placeholder="请输入代理商名称" filterable>
              <Option v-for="(option, index) in agent_list" :value="option.id" :key="index">{{ option.agent_name }}</Option>
            </Select>
          </FormItem>
          <!-- <FormItem label="推广大使" prop="">
            <Select v-model="user.user_type">
              <Option :value='0'>否</Option>
              <Option :value='1'>是</Option>
            </Select>
          </FormItem> -->
          <FormItem label="姓名" prop="nickname">
            <Input v-model="user.nickname" />
          </FormItem>
  
          <FormItem label="手机号" prop="mobile">
            <Input type="tel" v-model="user.mobile" />
          </FormItem>
          <FormItem label="邮箱" prop="email">
            <Input type="email" v-model="user.email" />
          </FormItem>
          <FormItem label="公司名称" prop="company">
            <Input v-model="user.company" />
          </FormItem>
          <FormItem label="头像" prop="headimgurl">
            <img :src="user.headimgurl" :style="{ 'width': '150px' }" />
            <Upload :action="getUploadUrl" :headers="uploadHeader" :on-success="successUpload">
              <Button icon="ios-cloud-upload-outline">上传图片</Button>
            </Upload>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="updateUser()">提交</Button>
          </FormItem>
        </Form>
      </Modal>
      <Modal v-model="showmodaldialogrecharge" :footer-hide=true title="对话权限配置">
        <Form ref="dialogrecharge" :model="dialogrecharge" :label-width="80">
          <FormItem label="开始时间" prop="start_time">
            <DatePicker type="date" placeholder="Select date" style="width: 200px" v-model="dialogrecharge.start_time">
            </DatePicker>
          </FormItem>
          <FormItem label="结束时间" prop="end_time">
            <DatePicker type="date" placeholder="Select date" style="width: 200px" v-model="dialogrecharge.end_time">
            </DatePicker>(此时间0时)
          </FormItem>
          <FormItem>
            <Button type="success" @click="updateDialogRecharge()">提交</Button>
          </FormItem>
        </Form>
        <br />
        <Table :columns="rechargeColumns" :data="recharge_list"></Table>
      </Modal>
  
      <Modal :width="600" v-model="model_price_modal" :footer-hide=true title="模型价格配置">
        <Form ref="model_price" :label-width="80">
          <FormItem label="模型价格" prop="model_price_list" style="width: 200px">
            <Select @on-change="computeModelPrice($event, 0)">
              <Option v-for="(item, index) in model_price_list" :value="index" v-if="item.price"  :key="index">{{ index }}</Option>
            </Select>
          </FormItem>
          <FormItem label="模型价格" prop="model_price">
            <Input v-model="model_price" type="textarea" :rows="8" placeholder="" />
          </FormItem>
          <FormItem>
            <Button type="success" @click="saveModelPrice()">提交</Button>
          </FormItem>
        </Form>
      </Modal>
  
  
      <Modal v-model="showmodaldialog" :footer-hide=true title="对话权益配置">
        <Form ref="dialog" :model="dialog" :label-width="80">
          <FormItem label="权益类型" prop="recharge_type" style="width: 200px">
            <Select v-model="dialog.recharge_type">
              <Option :value='30'>专属并发</Option>
              <Option :value='31'>通用并发</Option>
              <Option :value='34'>共享并发(非购买请选择这个)</Option>
              <Option :value='32'>4K并发</Option>
              <Option :value='33'>照片并发</Option>
              <Option :value='36'>预生成应用个数</Option>
            </Select>
          </FormItem>
          <FormItem label="权益(并发或次数)" prop="concurrency">
            <InputNumber v-model="dialog.concurrency" :min='0' controls-outside></InputNumber>
          </FormItem>
          <FormItem label="开始时间" prop="start_time">
            <DatePicker type="date" placeholder="Select date" style="width: 200px" v-model="dialog.start_time">
            </DatePicker>
          </FormItem>
          <FormItem label="结束时间" prop="end_time">
            <DatePicker type="date" placeholder="Select date" style="width: 200px" v-model="dialog.end_time"></DatePicker>
            (此时间0时)
          </FormItem>
          <FormItem>
            <Button type="success" @click="updateConcurrency()">提交</Button>
          </FormItem>
        </Form>
        <br />
        <Table :columns="concurrencyColumns" :data="concurrency_list"></Table>
      </Modal>
      <Modal v-model="showRechargeRecords" title="算力记录" width="1400px">
		<DatePicker type="month" placeholder="选择月份获取汇总数据" style="width: 250px" @on-change="handleDateChange"></DatePicker>
		<Select v-model="computility_recharge_type" @on-change="getRechargeRecords($event, 0)" style="width:150px">
			<Option :value="0">请选择</Option>
		  <Option :value="1">充值</Option>
		  <Option :value="2">消耗</Option>
		</Select>
		
        <Table :columns="rechargeRecordsColumns" :data="rechargeRecordsList"></Table>
        <Page :total="rechargeRecordTotal" :current="recordPage" :page-size="recordPageSize" :show-elevator="true"
          @on-change="getRechargeRecords" />
      </Modal>
      <!-- 分销伙伴级别弹窗 -->
      <Modal v-model="showPartnerLevel" :footer-hide="true" title="分销伙伴级别">
        <Form ref="partnerLevel" :model="partnerLevel" :label-width="120">
          <FormItem label="分销伙伴级别" prop="user_type">
            <Select v-model="partnerLevel.user_type" style="width:200px">
				<Option :value="0">请选择</Option>
              <Option :value="1">推广大使</Option>
              <Option :value="5">城市服务商</Option>
              <Option :value="10">业务合伙人</Option>
            </Select>
          </FormItem>
		  <FormItem label="备注" prop="desp">
		    <Input  type="textarea" v-model="partnerLevel.desp" />
		  </FormItem>
          <FormItem>
            <Button @click="showPartnerLevel = false" style="margin-left: 8px">取消</Button>&nbsp;&nbsp;&nbsp;&nbsp;
            <Button type="primary" @click="updatePartnerLevel">提交</Button>
          </FormItem>
        </Form>
      </Modal>
	  
	  <!-- 充值算力，带有效期 -->
	  <Modal v-model="showRechargeComputility" :footer-hide=true title="充值算力">
	    <Form ref="computilityRecharge" :model="computilityRecharge" :label-width="80">
	      <FormItem label="算力" prop="computility">
	        <Input v-model="computilityRecharge.computility" style="width: 200px"></Input>
	      </FormItem>
	      <FormItem label="开始日期" prop="start_time">
	        <DatePicker type="date" placeholder="Select date" format="yyyy-MM-dd" style="width: 200px" v-model="computilityRecharge.start_time">
	        </DatePicker>
	      </FormItem>
	      <FormItem label="结束日期" prop="end_time">
	        <DatePicker type="date" placeholder="Select date" format="yyyy-MM-dd" style="width: 200px" v-model="computilityRecharge.end_time"></DatePicker>
	      </FormItem>
	      <FormItem>
	        <Button type="success" @click="doRechargeComputility()">提交</Button>
	      </FormItem>
	    </Form>
	  </Modal>
    </Layout>
  </template>
  <script>
  import { formatDate } from '@/utils/date.js';
  export default {
  
    data() {
      return {
        search: {
          id: 0,
          mobile: "",
          agent_id: 0,
          nickname: "",
          playlet_member_level: "",
          channel: "",
          rights_level: "",
          applet_rights_level: "",
          inviter: "",
          account_type: -1
        },
        isEdit: true,
        showmodal: false,
        showApplet: false,//开通会员
        showPlaylet: false,//短剧会员
        showRecharge: false,//增值权益
		showRechargeComputility: false,//充算力
        showUserModal: false,//用户信息
        showmodaldialog: false,//对话权益配置
        showmodaldialogrecharge: false,//对话权限配置
        showmodalOthers: false,//其它权限配置
        showmodalOthersRecord: false,//新建或修改其它权限记录
        modalOthersRecordTitle: '新建',
		computility_recharge_type:0,
        rightOptions: [],
        loading2: false,
        loading3: false,
        user_list: [],
        agent_list: [],
        channel_list: [],
        concurrency_list: [],
        recharge_list: [],
        other_list: [],
        user_level: [],
        user_applet_level: [],
        user_playlet_level: [],
        tag_list: [],
        period: 0,
        period_list: [],
        applet_period: 0,
        applet_period_list: [],
        playlet_period: 0,
        playlet_period_list: [],
        rights_period: {//权限周期
          0: [{ "label": "无", "val": 0 }],
          1: [{ "label": "3天", "val": 259200 }],
          2: [{ "label": "7天", "val": 604800 }],
          4: [{ "label": "1年", "val": 31536000 }],
          5: [{ "label": "30天", "val": 2592000 }, { "label": "1年", "val": 31536000 }],
          6: [{ "label": "30天", "val": 2592000 }, { "label": "1年", "val": 31536000 }],
          7: [{ "label": "1天", "val": 86400 }, { "label": "3天", "val": 259200 }, { "label": "7天", "val": 604800 }, { "label": "15天", "val": 86400 * 15 }, { "label": "30天", "val": 2592000 }, { "label": "60天", "val": 86400 * 60 }, { "label": "1年", "val": 31536000 }, { "label": "2年", "val": 31536000 * 2 }, { "label": "3年", "val": 31536000 * 3 }, { "label": "5年", "val": 31536000 * 5 }],
          8: [{ "label": "1年", "val": 31536000 }, { "label": "2年", "val": 31536000 * 2 }, { "label": "3年", "val": 31536000 * 3 }, { "label": "4年", "val": 31536000 * 4 }, { "label": "5年", "val": 31536000 * 5 }],
          11: [{ "label": "30天", "val": 2592000 }, { "label": "1年", "val": 31536000 }, { "label": "2年", "val": 31536000 * 2 }, { "label": "3年", "val": 31536000 * 3 }, { "label": "4年", "val": 31536000 * 4 }, { "label": "5年", "val": 31536000 * 5 }],
          15: [{ "label": "1年", "val": 31536000 }, { "label": "2年", "val": 31536000 * 2 }, { "label": "3年", "val": 31536000 * 3 }, { "label": "4年", "val": 31536000 * 4 }, { "label": "5年", "val": 31536000 * 5 }],
        },
        applet_rights_period: {//权限周期
          0: [{ "label": "无", "val": 0 }],
          3: [{ "label": "7天", "val": 604800 }],
          4: [{ "label": "30天", "val": 2592000 }, { "label": "1年", "val": 31536000 }, { "label": "3年", "val": 31536000 * 3 }],
          5: [{ "label": "1年", "val": 31536000 }, { "label": "3年", "val": 31536000 * 3 }],
          6: [{ "label": "1年", "val": 31536000 }, { "label": "3年", "val": 31536000 * 3 }],
          7: [{ "label": "1年", "val": 31536000 }, { "label": "3年", "val": 31536000 * 3 }],
          8: [{ "label": "1年", "val": 31536000 }, { "label": "3年", "val": 31536000 * 3 }],
          9: [{ "label": "1年", "val": 31536000 }, { "label": "3年", "val": 31536000 * 3 }],
          15: [{ "label": "1年", "val": 31536000 }, { "label": "3年", "val": 31536000 * 3 }]
        },
        playlet_rights_period: {//短剧权限周期
          0: [{ "label": "无", "val": 0 }],
		  5: [{ "label": "7天", "val": 604800 }],  // 7天会员
          10: [{ "label": "30天", "val": 2592000 }],  // 月会员
          20: [{ "label": "90天", "val": 86400 * 90 }],  // 季会员
          30: [{ "label": "1年", "val": 31536000 }],  // 年会员
		   40: [{ "label": "1年", "val": 31536000 }], //专属会员
		  50: [{ "label": "1年", "val": 31536000 }],  //企业会员
		  60: [{ "label": "1年", "val": 31536000 }],   //企业会员L1
		  70: [{ "label": "1年", "val": 31536000 }],   //企业会员L2
		  80: [{ "label": "1年", "val": 31536000 }]    ,//企业会员L3
		},
        memberVip: {
          rights_level: [{ required: true, message: "请选择会员级别", trigger: "blur" }],
          start_time: [
            { required: true, message: "请选择开始时间", trigger: "blur" },
          ],
        },
        appletMemberVip: {
          applet_rights_level: [{ required: true, message: "请选择会员级别", trigger: "blur" }],
          applet_start_time: [
            { required: true, message: "请选择开始时间", trigger: "blur" },
          ],
        },
        playletMemberVip: {
          playlet_level: [{ required: true, message: "请选择会员级别", trigger: "blur" }],
          playlet_start_time: [
            { required: true, message: "请选择开始时间", trigger: "blur" },
          ],
        },
        recordTotal: 0,
        rechargeRecordTotal: 0,
        product_type_list: [], //产品类型
        page: 1,
        recordPage: 1,
        recordPageSize: 10,
        currentUserId: 0,
        rights: {
          id: '0',
          user_id: '0',
          start_time: "",
          end_time: "",
          rights_level: '0',
          applet_start_time: "",
          applet_end_time: "",
          applet_rights_level: '0',
          playlet_start_time: "",
          playlet_end_time: "",
          playlet_level: '0',
          leave_duration: '0',
          recharge_time: '0',
          use_duration: '0',
          clone_voice_number: '0',
          clone_voice_number_add: '0',
          talk_number: '0',
          talk_number_add: '0',
          talk_qanumber: '0',
          talk_qanumber_add: '0',
          quality_appearance_num: '0',
          quality_appearance_num_add: '0',
          speed_quality_appearance_num: '0',
          speed_quality_appearance_num_add: '0',
          high_quality_appearance_num: '0',
          high_quality_appearance_num_add: '0',
          super_quality_appearance_num_add: '0',
          photo_quality_appearance_num_add: '0',
          quality_voice_num: '0',
          high_quality_voice_num: '0',
          high_quality_voice_num_add: '0',
          figure_lingdong_num_add: '0',
          figure_lingdong_num: '0',
          word_number_recharge: 0,
          creation_end: '',
          real_time_start: '',
          real_time_end: '',
          real_time: '',
          creative_time_num: 0,
          creative_time: 0,
          use_creative_time_duration: 0,
          leave_creative_time_duration: 0,
          role_number_recharge: 0,
          role_number: 0,
          recharge_computility: 0,
          computility: 0,
          computility_consume: 0,
          rights: ['video', 'watermark']
        },
        user: {
          id: 0,
          nickname: "",
          company: '',
          mobile: '',
          email: '',
          channel: '',
          channel_name: '',
          headimgurl: "",
          industry: 0,
          agent_id: 0,
          //user_type: 0,
          account_type: 0
        },
        dialog: {
          user_id: 0,
          concurrency: 0,
          start_time: '',
          end_time: '',
          recharge_type: 30
        },
        dialogrecharge: {
          user_id: 0,
          start_time: '',
          end_time: ''
        },
        otherOptions: {
          id: 0,
          right: '',
          user_id: 0,
          start_time: '',
          end_time: ''
        },
        computilityRecharge:{//单独充值算力
          user_id:0,
          computility:0,
          start_time:'',
          end_time:''
        },
        model_price_modal:false,
        model_price_list:{},
        model_price:'',
        change_pwd_user_id: 0,
        change_pwd: '',
        video_group: [],
		    month_computility:'',
        userRule: {
          mobile: [
            { required: false, message: "请输入手机号码", trigger: "blur" },
  
            { validator: this.checkOneFieldFilled, trigger: 'blur' }
          ],
          email: [
            { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' },
            { required: false, message: '邮箱不能为空', trigger: 'blur' },
            { validator: this.checkOneFieldFilled, trigger: 'blur' }
          ],
          company: [
            { required: false, message: '公司名称不能为空', trigger: 'blur' }
          ],
          industry: [
            { required: false, message: '请选择行业', trigger: 'blur' }
          ]
        },
        concurrencyColumns: [
          {
            title: '并发类型', key: 'recharge_type', align: 'center', render: (h, params) => {
              var name = '未知';
              if (params.row.recharge_type == 30) {
                name = '专属并发';
              }
              if (params.row.recharge_type == 31) {
                name = '通用并发';
              }
              if (params.row.recharge_type == 32) {
                name = '4K并发';
              }
              if (params.row.recharge_type == 33) {
                name = '照片并发';
              }
              if (params.row.recharge_type == 34) {
                name = '共享并发';
              }
              if (params.row.recharge_type == 36) {
                name = '预生成应用个数';
              }
              return h('span', {}, name);
            }
          },
          { title: '开始时间', key: 'start_time', align: 'center' },
          { title: '结束时间', key: 'end_time', align: 'center' },
          { title: '权益(并发或次数)', key: 'recharge_time', align: 'center' },
          {
            title: '操作', key: 'action', align: 'center',
            render: (h, params) => {
              let btns = []
              if (params.row.recharge_type != 38) {
                btns.push(
                  h('Button', {
                    props: { type: 'info', size: 'small' },
                    style: { marginRight: '5px', marginBottom: '5px' },
                    on: {
                      click: () => {
                        this.delRechargeTime(params.row.id, 2, params.row.user_id)
                      }
                    }
                  }, '删除'),
                );
              }
  
              return h("div", btns);
            }
          }
        ],
        rechargeColumns: [
          { title: '开始时间', key: 'start_time', align: 'center' },
          { title: '结束时间', key: 'end_time', align: 'center' },
          {
            title: '操作', key: 'action', align: 'center',
            render: (h, params) => {
              let btns = []
              btns.push(
                h('Button', {
                  props: { type: 'info', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px' },
                  on: {
                    click: () => {
                      this.delRechargeTime(params.row.id, 1, params.row.user_id)
                    }
                  }
                }, '删除'),
              );
              return h("div", btns);
            }
          }
        ],
        is_super: localStorage.getItem("is_super"),
        tableColumns: [
          { title: '用户ID', key: 'id', align: 'center' },
          {
            title: '用户类型', key: 'account_type', align: 'center',
            render: (h, params) => {
              var typeName = '风平';
              if (params.row.account_type == 2) {
                typeName = '有戏';
              } else if (params.row.account_type == 5) {
                typeName = 'chatcar';
              } else if (params.row.account_type == 0) {
                typeName = '风平';
              }
			  if (params.row.user_type == 1) {
				  typeName += '-推广大使';
			  }
			  if (params.row.user_type == 5) {
			  		typeName += '-城市服务商';
			  }
			  if (params.row.user_type == 10) {
			  		typeName += '-合伙人';
			  }
	
              return h('span', {}, typeName);
            }
          },
          {
            title: '昵称', key: 'nickname', align: 'center',
            render: (h, params) => {
              var nickname = params.row.nickname;
              // if (params.row.company) {
              //   nickname += '(' + params.row.company + ')';
              // }
			  if (params.row.inviter_id) {
			  	nickname += "(邀请 "+params.row.inviter_id+")"
			  }
              return h('span', {}, nickname);
            }
          },
          { title: '所属代理商', key: 'agent_name', align: 'center' },
          {
            title: '会员信息', key: 'member_info', align: 'center', width: 332,
            render: (h, params) => {
              var rows = [];
              // 客户端会员信息
              if (params.row.rights_level_name) {
                var clientInfo = '客户端：' + params.row.rights_level_name;
                if (params.row.rights_time) {
                  clientInfo += ' （' + params.row.rights_time + '）';
                }
                rows.push(h('div', { style: { 'margin-bottom': '5px', 'line-height': '1.5' } }, clientInfo));
              } else {
                rows.push(h('div', { style: { 'margin-bottom': '5px', 'line-height': '1.5' } }, '客户端：-'));
              }
              // 小程序会员信息
              if (params.row.applet_rights_level_name) {
                var appletInfo = '小程序：' + params.row.applet_rights_level_name;
                if (params.row.applet_rights_time) {
                  appletInfo += ' （' + params.row.applet_rights_time + '）';
                }
                rows.push(h('div', { style: { 'margin-bottom': '5px', 'line-height': '1.5' } }, appletInfo));
              } else {
                rows.push(h('div', { style: { 'margin-bottom': '5px', 'line-height': '1.5' } }, '小程序：-'));
              }
              // 短剧会员信息（时间使用后端的 playlet_rights_time 字段）
              var playletInfo = '有戏：';
              if (params.row.playlet_level_name) {
                playletInfo += params.row.playlet_level_name;
              } else if (params.row.playlet_level && params.row.playlet_level > 0) {
                playletInfo += '等级' + params.row.playlet_level;
              } else {
                playletInfo += '-';
              }
              if (params.row.playlet_rights_time) {
                playletInfo += ' （' + params.row.playlet_rights_time + '）';
              }
              rows.push(h('div', { style: { 'line-height': '1.5' } }, playletInfo));
              return h('div', { style: { 'text-align': 'left', 'padding': '5px' } }, rows);
            }
          },
          {
            title: '时长(总/用)', key: 'video_duration', align: 'center',
            render: (h, params) => {
              var total = parseFloat(params.row.video_duration || 0);
              var used = parseFloat(params.row.use_video_duration || 0);
              return h('span', {}, total + '/' + used);
            }
          },
          {
            title: '算力(剩/用)', key: 'computility', align: 'center',
            render: (h, params) => {
              var remaining = parseFloat(params.row.computility || 0);
              var consumed = parseFloat(params.row.computility_consume || 0);
              return h('span', {}, remaining + '/' + consumed);
            }
          },
          { title: '渠道', key: 'channel_name', align: 'center' },
          { title: '创建时间', key: 'created_at', align: 'center' },
          {
            title: '会员', key: 'member_action', align: 'center',
            render: (h, params) => {
              let btns = []
              btns.push(
                h('Button', {
                  props: { type: 'info', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px' },
                  on: {
                    click: () => {
                      this.rights.recharge_time = 0;
                      this.rights.end_time = '';
                      this.rights.start_time = '';
                      this.rights.rights_level = 0;
                      this.rights.rights = [];
                      this.period = 0;
                      this.getUserRights(params.row.id);
  
                      this.showmodal = true;
                    }
                  }
                }, '客户端权限'),
              );
              btns.push(
                h('Button', {
                  props: { type: 'info', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px' },
                  on: {
                    click: () => {
                      this.rights.applet_end_time = '';
                      this.rights.applet_start_time = '';
                      this.rights.applet_rights_level = 0;
                      this.rights.rights = [];
                      this.applet_period = 0;
                      this.getUserRights(params.row.id);
  
                      this.showApplet = true;
                    }
                  }
                }, '小程序权限'),
              );
              btns.push(
                h('Button', {
                  props: { type: 'info', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px' },
                  on: {
                    click: () => {
                      // 重置短剧相关字段，权限数组固定为空
                      this.rights.playlet_end_time = '';
                      this.rights.playlet_start_time = '';
                      this.rights.playlet_level = 0;
                      this.rights.rights = [];
                      this.playlet_period = 0;
                      this.playlet_period_list = this.playlet_rights_period[0];
                      this.getUserRights(params.row.id);
  
                      this.showPlaylet = true;
                    }
                  }
                }, '有戏权限'),
              );
              // 当 channel=playlet 时显示分销伙伴级别按钮
              if (params.row.channel === 'playlet') {
                btns.push(
                  h('Button', {
                    props: { type: 'info', size: 'small' },
                    style: { marginRight: '5px', marginBottom: '5px' },
                    on: {
                      click: () => {
                        this.showPartnerLevelModal(params.row);
                      }
                    }
                  }, '分销伙伴级别'),
                );
              }
              return h("div", btns);
            }
          },
          {
            title: '权限', key: 'right_action', align: 'center',
            render: (h, params) => {
              let btns = []
              var timestamp = Date.parse(new Date());
              timestamp = timestamp / 1000;
              // 增值权益
              btns.push(
                h('Button', {
                  props: { type: 'info', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px' },
                  on: {
                    click: () => {
                      this.getUserRights(params.row.id);
                      this.showRecharge = true;
                    }
                  }
                }, '增值权益'),
              );
              // 判断用户的
              if (this.is_super == 1) {
                btns.push(
                  h('Button', {
                    props: { type: 'primary', size: 'small' },
                    style: { marginRight: '5px', marginBottom: '5px' },
                    on: {
                      click: () => {
                        this.dialog.user_id = params.row.id;
                        this.getconcurrencyList(params.row.id, 30);
                        this.showmodaldialog = true;
                      }
                    }
                  }, '实时流权益'),
                );
              }
              btns.push(
                h('Button', {
                  props: { type: 'primary', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px' },
                  on: {
                    click: () => {
                      this.dialogrecharge.user_id = params.row.id;
                      this.getRechargeList(params.row.id);
                      this.showmodaldialogrecharge = true;
                    }
                  }
                }, '对话权限'),
              );
              btns.push(
                h('Button', {
                  props: { type: 'primary', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px' },
                  on: {
                    click: () => {
                      this.user.id = params.row.id;
                      this.model_price = JSON.stringify(params.row.model_price);
                      this.getModelPrice();
                      this.model_price_modal = true;
                    }
                  }
                }, '模型价格'),
              );
              return h("div", btns);
            }
          },
          {
            title: '操作', key: 'action', align: 'center',
            render: (h, params) => {
              let btns = []
              btns.push(
                h('Button', {
                  props: { type: 'warning', size: 'small' },
                  style: { marginRight: '15px', marginBottom: '5px' },
                  on: {
                    click: () => {
                      this.getSettingList();
                      this.user.id = params.row.id;
                      this.user.mobile = params.row.mobile;
                      this.user.nickname = params.row.nickname;
                      this.user.company = params.row.company;
                      this.user.logo = params.row.logo;
                      this.user.channel = params.row.channel;
                      this.user.agent_id = params.row.agent_id;
                      this.user.industry = params.row.industry;
                      this.user.video_group = params.row.video_group;
                      //this.user.user_type = parseInt(params.row.user_type);
                      this.user.account_type = params.row.account_type !== undefined ? parseInt(params.row.account_type) : 0;
                      this.showUserModal = true;
                    }
                  }
                }, '编辑'),
              );
			  btns.push(
			    h('Button', {
			      props: { type: 'warning', size: 'small' },
			      style: { marginRight: '5px', marginBottom: '5px' },
			      on: {
			        click: () => {
			          this.computilityRecharge.user_id = params.row.id;
                this.computilityRecharge.computility = 0;
                this.computilityRecharge.start_time = new Date();
                this.computilityRecharge.end_time = '';
			          this.showRechargeComputility = true;
			        }
			      }
			    }, '充算力'),
			  );
              btns.push(
                h('Button', {
                  props: { type: 'success', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px' },
                  on: {
                    click: () => {
                      this.change_pwd_user_id = params.row.id;
                      this.changepwd();
                    }
                  }
                }, '设置密码'),
              );
              btns.push(
                h('Button', {
                  props: { type: 'info', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px' },
                  on: {
                    click: () => {
                      this.currentUserId = params.row.id;
                      this.recordPage = 1
                      console.log("params", params)
                      this.getRechargeRecords();
                      this.showRechargeRecords = true;
                    }
                  }
                }, '算力记录'),
              );
  
              return h("div", btns);
            }
          }
        ],
        uploadHeader: {
          "Authorization": localStorage.getItem('token')
        },
        showRechargeRecords: false,
        rechargeRecordsList: [],
        rechargeRecordsColumns: [
          { title: '充值ID', key: 'id', align: 'center' },
      { title: '充值类型', key: 'recharge_type_name', align: 'center', width:'170px'},
          { title: '相关ID', key: 'relation_id', align: 'center' },
          { title: '相关子ID', key: 'relation_sub_id', align: 'center' },
          { title: '商品ID', key: 'product_id', align: 'center' },
          { title: '时长/次数', key: 'recharge_time', align: 'center' },
          { title: '时效-结束时间', key: 'end_time', align: 'center', width: '170px' },
          { title: '创建时间', key: 'created_at', align: 'center', width: '170px' },
        ],
        showPartnerLevel: false,
        partnerLevel: {
          user_id: 0,
          user_type: 0,
		  desp:''
        },
        // 其它权限的列表
        otherColumns: [
          { title: '权限', key: 'right_name', align: 'center' },
          { title: '开始时间', key: 'start_time', align: 'center' },
          { title: '结束时间', key: 'end_time', align: 'center' },
          {
            title: '操作', key: 'action', align: 'center',
            render: (h, params) => {
              let btns = []
              btns.push(
                h('Button', {
                  props: { type: 'info', size: 'small' },
                  style: { marginRight: '5px', marginBottom: '5px' },
                  on: {
                    click: () => {
                      // 编辑其他权限记录
                      const currentIndex = params.index;
                      this.otherOptions.id = this.other_list[currentIndex].id;
                      this.otherOptions.right = this.other_list[currentIndex].right;
                      this.otherOptions.start_time = this.other_list[currentIndex].start_time;
                      this.otherOptions.end_time = this.other_list[currentIndex].end_time;
                      this.toggleModalOthersRecord(true);
                    }
                  }
                }, '编辑'),
              );
              return h("div", btns);
            }
          }
        ]
      }
    },
    mounted: function () {
      this.getTagList();
      this.getUserList();
      this.getUserLevels();
      this.getUserAppletLevels();
      this.getUserPlayletLevels();
      this.getChannelList();
      this.agentlistAll();
      this.getProductTypeList();
    },
    computed: {
      getUploadUrl() {
        return process.env.VUE_APP_APIHOST + '/admin/material/upload';
      }
    },
    methods: {
      getModelPrice(){
        this.http.get('/admin/common/getModelprice').then(response => {
          let data = response.data;
          if (data.code !== 0) {
            alert(data.message);
          } else {
            this.model_price_list = data.data
          }
        }).catch(() => {
          this.$Message.error('网络错误');
        });
      },
      computeModelPrice(value, index){
        //this.model_price = value
        //console.log(this.model_price)
        this.http.post('/admin/user/getModelprice', {
            user_id: this.user.id,
            model: value,
            model_price:this.model_price
        }).then(response => {
          let data = response.data;
          if (data.code !== 0) {
            this.$Message.error(data.message);
            return false;
          } else {
            this.model_price = data.data
            return true;
          }
        });
      },
      saveModelPrice(){
        this.http.post('/admin/user/saveModelprice', {
            user_id: this.user.id,
            model_price: this.model_price,
        }).then(response => {
          let data = response.data;
          if (data.code !== 0) {
            this.$Message.error(data.message);
            return false;
          } else {
            this.$Message.info(data.message);
            return true;
          }
        });
      },
      handleDateChange(value, date) {
        
            console.log('选中的日期:', value); // value是格式化的日期字符串，例如"2023-04-01"
            console.log('原始的日期对象:', date); // date是JavaScript Date对象
          let p = { 'month': value, 'user_id': this.currentUserId }
          this.http.get('/admin/user/computilityMonthstatic', { params: p }).then(response => {
            let data = response.data;
            console.log(data);
            if (data.code !== 0) {
              alert(data.message);
            } else {
          this.$Message.info({
                              content: '消耗算力:'+data.res.consume_total,
                              duration: 15,
                              closable: true
                          });
            }
          }).catch(() => {
            this.$Message.error('网络错误');
          });
      },
      TimeFromater(isoDate) {
        const date = new Date(isoDate);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      },
      getUserRightList() {
        this.http1.get('/user_right/rightlist')
          .then(response => {
            let data = response.data;
            if (data.code !== 0) {
              alert(data.message);
            } else {
              // console.log('data',data.data)
              let temp = Object.keys(data.data)
              let temp1 = Object.values(data.data).map(item => item.name)
              this.rightOptions = temp.map((item, index) => {
                return {
                  engTag: item,
                  name: temp1[index]
                }
              })
              // console.log('rightOptions',this.rightOptions)
            }
          })
          .catch(error => {
            this.$Message.error('网络错误');
            console.error('请求出错:', error);
          });
      },
      toggleModalOthersRecord(flag) {
        this.isEdit = flag;
        if (flag) {
          this.modalOthersRecordTitle = '编辑';
        } else {
          this.modalOthersRecordTitle = '新建';
        }
        this.getUserRightList();
        this.showmodalOthersRecord = true;
      },
      checkOneFieldFilled(rule, value, callback) {
        if (!this.user.mobile && !this.user.email) {
          callback('手机号或邮箱至少需要填写一项');
        } else {
          callback();
        }
      },
      getTagList() {
        this.http.get('/admin/user/tags').then(response => {
          let data = response.data;
          // console.log(data);
          if (data.code !== 0) {
            alert(data.message);
          } else {
            this.tag_list = data.data;
          }
        }).catch(() => {
          this.$Message.error('网络错误');
        });
      },
      getconcurrencyList(user_id, recharge_type) {
        let p = { 'recharge_type': recharge_type, 'user_id': user_id }
        this.http.get('/admin/user/rechargeList', { params: p }).then(response => {
          let data = response.data;
          console.log(data);
          if (data.code !== 0) {
            alert(data.message);
          } else {
            this.concurrency_list = data.data.list;
          }
        }).catch(() => {
          this.$Message.error('网络错误');
        });
      },
      getRechargeList(user_id) {
        let p = { 'recharge_type': 35, 'user_id': user_id }
        this.http.get('/admin/user/rechargeList', { params: p }).then(response => {
          let data = response.data;
          console.log(data);
          if (data.code !== 0) {
            alert(data.message);
          } else {
            this.recharge_list = data.data.list;
          }
        }).catch(() => {
          this.$Message.error('网络错误');
        });
      },
	  doRechargeComputility(){//单独充值算力
		  this.http.post('/admin/user/rechargeComputility', {
		    user_id: this.computilityRecharge.user_id,
		    start_time: this.computilityRecharge.start_time,
		    end_time: this.computilityRecharge.end_time,
		    computility: this.computilityRecharge.computility,
		  }).then(response => {
		    let data = response.data;
		    if (data.code !== 0) {
		      this.$Message.error(data.message);
		      return false;
		    } else {
		      this.$Message.info(data.message);
		      return true;
		    }
		  });
		  this.showRechargeComputility = false;
	  },
      updateConcurrency() {
        this.http.post('/admin/user/rechargeConcurrency', {
          user_id: this.dialog.user_id,
          start_time: this.dialog.start_time,
          end_time: this.dialog.end_time,
          concurrency: this.dialog.concurrency,
          recharge_type: this.dialog.recharge_type
        }).then(response => {
          let data = response.data;
          if (data.code !== 0) {
            this.$Message.error(data.message);
            return false;
          } else {
            this.$Message.info(data.message);
            this.dialog.start_time = '';
            this.dialog.end_time = '';
            this.dialog.concurrency = 0;
            this.dialog.recharge_type = 30;
            this.getconcurrencyList(this.dialog.user_id, 30);
            return true;
          }
        });
      },
      delRechargeTime(recharge_id, type = 1, user_id) {//删除充值记录
        this.$Modal.confirm({
          title: '删除',
          content: '<p>确定删除</p>',
          onOk: () => {
            this.http.post('/admin/user/delRecharge', {
              recharge_id: recharge_id
            }).then(response => {
              let data = response.data;
              if (data.code !== 0) {
                this.$Message.error(data.message);
                return false;
              } else {
                if (type == 1) {
                  this.getRechargeList(user_id)
                  //this.recharge_list.slice(index, 1);
                } else {
                  this.getconcurrencyList(user_id, 30);
                  //this.concurrency_list.slice(index, 1);
                }
                return true;
              }
            });
          }
        });
      },
      updateDialogRecharge() {
        this.http.post('/admin/user/rechargeConcurrency', {
          user_id: this.dialogrecharge.user_id,
          start_time: this.dialogrecharge.start_time,
          end_time: this.dialogrecharge.end_time,
          concurrency: 0,
          recharge_type: 35
        }).then(response => {
          let data = response.data;
          if (data.code !== 0) {
            this.$Message.error(data.message);
            return false;
          } else {
            this.$Message.info(data.message);
            this.dialogrecharge.start_time = '';
            this.dialogrecharge.end_time = '';
            this.getRechargeList(this.dialogrecharge.user_id);
            return true;
          }
        });
      },
      clearOtherOptions() {
        //  清空其他权限的选项
        // this.otherOptions.user_id = 0;
        this.otherOptions.id = 0;
        this.otherOptions.right = '';
        this.otherOptions.start_time = '';
        this.otherOptions.end_time = '';
      },
      createUserRights() {
        //新增其他权限的列表
        const startTime = this.TimeFromater(this.otherOptions.start_time);
        const endTime = this.TimeFromater(this.otherOptions.end_time);
        this.http1.post('/user_right/addUserRight'
          , {
            user_id: this.otherOptions.user_id,
            right: this.otherOptions.right,
            start_time: startTime,
            end_time: endTime,
          }).then(response => {
            console.log("新建其它权限记录", response.data)
            let data = response.data;
            if (data.code !== 0) {
              this.$Message.error(data.message);
              return false;
            } else {
              // 刷新展示的列表
              this.getOtherRightList(this.otherOptions.user_id);
              // 关闭当前弹窗
              this.showmodalOthersRecord = false;
              return true;
            }
          }).catch(() => {
            this.$Message.error('网络错误');
          }).finally(() => {
            this.clearOtherOptions()
          });
      },
      updateUserRights() {
        //修改其他权限的列表
        const startTime = this.TimeFromater(this.otherOptions.start_time);
        const endTime = this.TimeFromater(this.otherOptions.end_time);
        this.http1.post("/user_right/updateUserRight"
          , {
            user_id: this.otherOptions.user_id,
            id: this.otherOptions.id,
            right: this.otherOptions.right,
            start_time: startTime,
            end_time: endTime,
          }).then(response => {
            console.log("修改其它权限记录", response.data)
            let data = response.data;
            if (data.code !== 0) {
              this.$Message.error(data.message);
              return false;
            } else {
              // 刷新展示的列表
              this.getOtherRightList(this.otherOptions.user_id);
              // 关闭当前弹窗
              this.showmodalOthersRecord = false;
            }
          }).catch(() => {
            this.$Message.error('网络错误');
          }).finally(() => {
            this.clearOtherOptions()
          })
      },
      getOtherRightList() {
        //获取其他权限的列表
        this.http1.get('/user_right/list', { params: { user_id: this.otherOptions.user_id } })
          .then(response => {
            let data = response.data;
            if (data.code !== 0) {
              alert(data.message);
            } else {
              this.other_list = data.data;
              console.log("other_list", this.other_list)
            }
          }).catch(() => {
            this.$Message.error('网络错误');
          });
      },
      addUserModal() {
        this.user.id = 0;
        this.user.nickname = '';
        this.user.mobile = '';
        this.user.company = '';
        this.user.logo = '';
        this.user.industry = 0;
        this.user.video_group = 0;
        this.user.pwd = '';
        this.user.agent_id = 0;
        this.user.account_type = 0;
        this.showUserModal = true;
      },
      changepwd() {
        this.$Modal.confirm({
          onOk: () => {
            this.http1.post('/user/changePwd', {
              'user_id': this.change_pwd_user_id,
              'pwd': this.change_pwd
            }).then(response => {
              console.log(response)
              let data = response.data;
  
              if (data.code !== 0) {
                this.$Message.error(data.message);
                return false;
              } else {
                this.$Message.info('成功');
                return true;
              }
            }).catch(function (error) { // 请求失败处理
              console.log(error);
            });
          },
          render: (h) => {
            return h('Input', {
              props: {
                value: this.value,
                autofocus: true,
                placeholder: '请输入六位密码',
                maxlength: '6'
              },
              on: {
                input: (val) => {
                  this.change_pwd = val;
                }
              }
            })
          }
        })
      },
      getUserList(page = this.page) {
        this.page = page;
        let p = { 'page': page }
        let params = Object.assign(this.search, p);
        this.http.get('/admin/user/userList', { params: params }).then(response => {
          let data = response.data;
          if (data.code !== 0) {
            alert(data.message);
          } else {
            this.user_list = data.data.list;
            this.recordTotal = data.data.total;
          }
        }).catch(() => {
          this.$Message.error('网络错误');
        });
      },
      getChannelList() {
        this.http.get('/admin/agent/channelList').then(response => {
          let data = response.data;
          if (data.code !== 0) {
            alert(data.message);
          } else {
            if (data.data) {
              this.channel_list = data.data;
            }
          }
        }).catch(() => {
          this.$Message.error('网络错误');
        });
      },
      getUserRights(user_id) {
        const now_time = new Date().valueOf()
        this.rights.user_id = user_id;
        this.http.get('/admin/user/getUserRights', { params: { user_id: user_id } }).then(response => {
          let data = response.data;
          if (data.code !== 0) {
            alert(data.message);
          } else {
            if (data.data) {
              this.rights = data.data;
              // 处理剩余时长精度
              if (typeof data.data.leave_duration !== 'undefined' && data.data.leave_duration !== null) {
                this.rights.leave_duration = parseFloat(parseFloat(data.data.leave_duration).toFixed(2));
              }
              // 实时驱动时间回显
              if (parseInt(data.data.real_time_end) * 1000) {
                this.rights.real_time_start = formatDate(new Date(parseInt(data.data.real_time_start) * 1000), 'yyyy-MM-dd');
                this.rights.real_time_end = formatDate(new Date(parseInt(data.data.real_time_end) * 1000), 'yyyy-MM-dd');
              }
              // 短剧会员等级回显（与下拉选项类型保持一致）
              if (typeof data.data.playlet_level !== 'undefined' && data.data.playlet_level !== null) {
                const level = parseInt(data.data.playlet_level, 10);
                this.rights.playlet_level = isNaN(level) ? 0 : level;
              } else {
                this.rights.playlet_level = 0;
              }
              // 短剧开始/结束时间回显
              // 后端如果已经返回了格式化日期（如 2025-12-25），直接使用；
              // 如果返回的是纯数字时间戳，再做一次格式化，避免 1970-01-01。
              const rawPlayletStart = data.data.playlet_start_time;
              const rawPlayletEnd = data.data.playlet_end_time;
              this.rights.playlet_start_time = '';
              this.rights.playlet_end_time = '';
              // 处理开始时间：排除空值、'-'、'0' 等无效值
              if (rawPlayletStart && rawPlayletStart !== '-' && rawPlayletStart !== '0' && rawPlayletStart !== 0) {
                const ps = rawPlayletStart.toString();
                if (/^\d+$/.test(ps) && parseInt(ps, 10) > 1000000000) {
                  this.rights.playlet_start_time = formatDate(new Date(parseInt(ps, 10) * 1000), 'yyyy-MM-dd');
                } else if (!/^\d+$/.test(ps)) {
                  // 非纯数字，可能是已格式化的日期字符串
                  this.rights.playlet_start_time = ps;
                }
                // 纯数字但小于有效时间戳阈值的情况，保持为空
              }
              // 处理结束时间：排除空值、'-'、'0' 等无效值
              if (rawPlayletEnd && rawPlayletEnd !== '-' && rawPlayletEnd !== '0' && rawPlayletEnd !== 0) {
                const pe = rawPlayletEnd.toString();
                if (/^\d+$/.test(pe) && parseInt(pe, 10) > 1000000000) {
                  this.rights.playlet_end_time = formatDate(new Date(parseInt(pe, 10) * 1000), 'yyyy-MM-dd');
                } else if (!/^\d+$/.test(pe)) {
                  // 非纯数字，可能是已格式化的日期字符串
                  this.rights.playlet_end_time = pe;
                }
                // 纯数字但小于有效时间戳阈值的情况，保持为空
              }
              this.rights.rights_level = parseInt(data.data.rights_level);
              this.period_list = this.rights_period[this.rights.rights_level];
              this.rights.applet_rights_level = parseInt(data.data.applet_rights_level);
              this.applet_period_list = this.applet_rights_period[this.rights.applet_rights_level];
              // 短剧权限有效期列表初始化
              this.playlet_period_list = this.playlet_rights_period[this.rights.playlet_level] || this.playlet_rights_period[0];
              this.computePeriodTime();
            }
          }
        }).catch(() => {
          this.$Message.error('网络错误');
        });
      },
      closeModal() {
        this.showmodal = false;
        this.showApplet = false;
        this.showRecharge = false;
        this.showPlaylet = false;
      },
      updateRights(type) {
        console.log(this.rights.start_time);
        this.$refs["rights"].validate((valid) => {
          if (valid) {
            this.http.post('/admin/user/editRights', {
              'type': type,
              'user_id': this.rights.user_id,
              // 短剧权限的权限字段固定传空数组
              'rights': type === 2 ? [] : this.rights.rights,
              'rights_level': this.rights.rights_level,
              'start_time': this.rights.start_time,
              'end_time': this.rights.end_time,
              'applet_rights_level': this.rights.applet_rights_level,
              'applet_start_time': this.rights.applet_start_time,
              'applet_end_time': this.rights.applet_end_time,
              'playlet_level': this.rights.playlet_level,
              'playlet_start_time': this.rights.playlet_start_time,
              'playlet_end_time': this.rights.playlet_end_time
            }).then(response => {
              let data = response.data;
              if (data.code !== 0) {
                this.$Message.error(data.message);
                return false;
              } else {
                this.$Message.info(data.message);
                this.showmodal = false;
                this.showApplet = false;
                this.showPlaylet = false;
                this.getUserList(this.page);
                return true;
              }
            });
          }
        })
      },
      updateRecharge() {
        this.http.post('/admin/user/rechargeTime', {
          'user_id': this.rights.user_id,
          'recharge_time': this.rights.recharge_time,
          'recharge_computility': this.rights.recharge_computility,
          'real_time': this.rights.real_time,
          'word_number': this.rights.word_number_recharge,
          'creative_time': this.rights.creative_time_num,
          'role_number': this.rights.role_number_recharge,
          'clone_voice_number': this.rights.clone_voice_number_add,
          'high_quality_voice_num': this.rights.high_quality_voice_num_add,
          'talk_number': this.rights.talk_number_add,
          'talk_qanumber': this.rights.talk_qanumber_add,
          'quality_appearance_num': this.rights.quality_appearance_num_add,
          'speedy_quality_appearance_num': this.rights.speedy_quality_appearance_num_add,
          'high_quality_appearance_num': this.rights.high_quality_appearance_num_add,
          'super_quality_appearance_num': this.rights.super_quality_appearance_num_add,
          'photo_quality_appearance_num': this.rights.photo_quality_appearance_num_add,
          'figure_lingdong_num': this.rights.figure_lingdong_num_add
        }).then(response => {
          let data = response.data;
          if (data.code !== 0) {
            this.$Message.error(data.message);
            return false;
          }
          else {
            this.$Message.info(data.message);
            this.showRecharge = false;
            return true;
          }
        });
      },
      updateUser() {
        this.$refs['user'].validate((valid) => {
          if (valid) {
            this.http.post('/admin/user/edit', {
              'id': this.user.id,
              'nickname': this.user.nickname,
              'mobile': this.user.mobile,
              'email': this.user.email,
              'agent_id': this.user.agent_id,
              'company': this.user.company,
              'channel': this.user.channel,
              'headimgurl': this.user.headimgurl,
              'industry': this.user.industry,
              'user_type': this.user.user_type,
              'video_group': this.user.video_group,
              'account_type': this.user.account_type
            }).then(response => {
              let data = response.data;
              if (data.code !== 0) {
                this.$Message.error(data.message);
                return false;
              }
              else {
                this.$Message.info(data.message);
                this.showUserModal = false;
                this.getUserList(this.page);
                return true;
              }
            });
          }
        });
      },
      getUserLevels() {
        this.http.get('/admin/user/userLevels').then(response => {
          let data = response.data;
          if (data.code !== 0) {
            alert(data.message);
          } else {
            if (data.data) {
              this.user_level = data.data;
            }
          }
        }).catch(() => {
          this.$Message.error('网络错误');
        });
      },
      getUserAppletLevels() {
        this.http.get('/admin/user/userAppletLevels').then(response => {
          let data = response.data;
          if (data.code !== 0) {
            alert(data.message);
          } else {
            if (data.data) {
              this.user_applet_level = data.data;
            }
          }
        }).catch(() => {
          this.$Message.error('网络错误');
        });
      },
      getUserPlayletLevels() {
        this.http.get('/admin/user/userLevels', { params: { user_level_key: 'playlet_member_level' } }).then(response => {
          let data = response.data;
          if (data.code !== 0) {
            alert(data.message);
          } else {
            if (data.data) {
              this.user_playlet_level = data.data;
            }
          }
        }).catch(() => {
          this.$Message.error('网络错误');
        });
      },
      agentlist(query) {
        if (query !== '' && query.length >= 2) {
          this.loading2 = true;
          setTimeout(() => {
            this.loading2 = false;
  
            this.http.get('/admin/agent/agList', { params: { company: query } }).then(response => {
              let data = response.data;
              if (data.code !== 0) {
                alert(data.message);
              } else {
                this.agent_list = data.data.list;
              }
            }).catch(() => {
              this.$Message.error('网络错误');
            });
  
          }, 200);
        }
      },
      agentlistAll(query) {
        this.loading2 = true;
        setTimeout(() => {
          this.loading2 = false;
  
          this.http.get('/admin/agent/agList', { params: { company: query, pagesize: 9999 } }).then(response => {
            let data = response.data;
            if (data.code !== 0) {
              alert(data.message);
            } else {
              this.agent_list = data.data.list;
            }
          }).catch(() => {
            this.$Message.error('网络错误');
          });
  
        }, 200);
      },
      getSettingList() {
        if (this.video_group.length == 0) {
          this.http.get('/admin/common/settingKey', { params: { 'key': 'video_group' } }).then(response => {
            let data = response.data;
            if (data.code !== 0) {
              alert(data.message);
            } else {
              this.video_group = data.data;
              //console.log(this.video_group)
            }
          }).catch(() => {
            this.$Message.error('网络错误');
          });
        }
      },
      successUpload(response, file, fileList) {
        let data = response
        if (data.code != 0) {
          this.$Message.error(data.message);
          return true;
        }
        this.user.headimgurl = data.data.url;
      },
      computeTime(e, type) {//根据权限ID，计算时长
        if (e == 0 || e == undefined) {
          return false;
        }
        //type:0客户端,1小程序,2短剧
        if (type == 1) {
          this.applet_period_list = this.applet_rights_period[e];
          this.applet_period = this.applet_rights_period[e][0]['val'];
          for (let item of this.user_applet_level) {
            if (item.id == e) {
              this.rights.rights = item.rights;
            }
          }
          if (this.rights.applet_start_time) {
            var applet_end_time = this.dateToTimestamp(this.rights.applet_start_time) + parseInt(this.applet_period);
            this.rights.applet_end_time = this.timestampToDate(applet_end_time);
          }
        } else if (type == 2) {
          // 短剧权限
          this.playlet_period_list = this.playlet_rights_period[e] || this.playlet_rights_period[0];
          this.playlet_period = this.playlet_period_list[0]['val'];
          if (this.rights.playlet_start_time) {
            var playlet_end_time = this.dateToTimestamp(this.rights.playlet_start_time) + parseInt(this.playlet_period);
            this.rights.playlet_end_time = this.timestampToDate(playlet_end_time);
          }
        } else {
          this.period_list = this.rights_period[e];
          this.period = this.rights_period[e][0]['val'];
          for (let item of this.user_level) {
            if (item.id == e) {
              this.rights.rights = item.rights;
            }
          }
          if (this.rights.start_time) {
            var end_time = this.dateToTimestamp(this.rights.start_time) + parseInt(this.period);
            this.rights.end_time = this.timestampToDate(end_time);
          }
        }
      },
      computePeriodTime() {//修改时，计算有效期回显
        if (this.rights.start_time && this.rights.end_time) {//新选的时长，从新计算结束时间
          this.period = this.dateToTimestamp(this.rights.end_time) - this.dateToTimestamp(this.rights.start_time)
          //console.log(this.period);
        }
        if (this.rights.applet_start_time && this.rights.applet_end_time) {//新选的时长，从新计算结束时间
          this.applet_period = this.dateToTimestamp(this.rights.applet_end_time) - this.dateToTimestamp(this.rights.applet_start_time)
          //console.log(this.period);
        }
        if (this.rights.playlet_start_time && this.rights.playlet_end_time) {//短剧权限有效期回显
          this.playlet_period = this.dateToTimestamp(this.rights.playlet_end_time) - this.dateToTimestamp(this.rights.playlet_start_time)
        }
      },
      computePeriod(e, type) {//开始时间变化计算时长
        console.log(e);
        console.log(this.period)
        if (e) {
          //type:0客户端,1小程序,2短剧
          if (type == 1) {
            this.rights.applet_start_time = e;
            var applet_end_time = this.dateToTimestamp(e) + parseInt(this.applet_period);
            this.rights.applet_end_time = this.timestampToDate(applet_end_time);
          } else if (type == 2) {
            // 短剧权限
            this.rights.playlet_start_time = e;
            var playlet_end_time = this.dateToTimestamp(e) + parseInt(this.playlet_period);
            this.rights.playlet_end_time = this.timestampToDate(playlet_end_time);
          } else {
            this.rights.start_time = e;
            var end_time = this.dateToTimestamp(e) + parseInt(this.period);
            this.rights.end_time = this.timestampToDate(end_time);
          }
        }
      },
      changePeriodTime(e, type) {//时长选择有变化
        //type:0客户端,1小程序,2短剧
        if (type == 1) {
          if (this.rights.applet_start_time) {
            var applet_end_time = this.dateToTimestamp(this.rights.applet_start_time) + e;
            this.rights.applet_end_time = this.timestampToDate(applet_end_time);
          }
        } else if (type == 2) {
          // 短剧权限
          if (this.rights.playlet_start_time) {
            var playlet_end_time = this.dateToTimestamp(this.rights.playlet_start_time) + e;
            this.rights.playlet_end_time = this.timestampToDate(playlet_end_time);
          }
        } else {
          if (this.rights.start_time) {
            var end_time = this.dateToTimestamp(this.rights.start_time) + e;
            this.rights.end_time = this.timestampToDate(end_time);
          }
        }
      },
      dateToTimestamp(datestr) {
        var date = new Date(datestr);
        var time = Date.parse(date);
  
        var timestamp = time / 1000; //除1000得到时间戳
        return timestamp - 3600 * 8;
      },
      timestampToDate(n) {
        let now = new Date(n * 1000),
          y = now.getFullYear(),
          m = now.getMonth() + 1,
          d = now.getDate();
        return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d);
      },
      getRechargeRecords(page = this.recordPage) {
		  var computility_recharge_type = this.computility_recharge_type;
        this.http.get('/admin/user/getRechargeRecords', {
          params: { user_id: this.currentUserId, page: page, pageSize: this.recordPageSize,computility_recharge_type:computility_recharge_type }
        }).then(response => {
          let data = response.data;
          if (data.code !== 0) {
            this.$Message.error(data.message);
          } else {
            this.rechargeRecordsList = data.data;
            this.rechargeRecordTotal = data.total;
          }
        }).catch((e) => {
          this.$Message.error(e);
        });
      },
      getProductTypeList() {
        this.http.get('/admin/product/getProductTypeList').then(response => {
          let data = response.data
          let len = Object.keys(data.data).length
          this.product_type_list = data.data;
        });
      },
      showPartnerLevelModal(row) {
        this.partnerLevel.user_id = row.id;
        this.partnerLevel.user_type = parseInt(row.user_type) || 0;
		this.partnerLevel.desp = '';
        this.showPartnerLevel = true;
      },
      updatePartnerLevel() {
        this.http1.post('/user/updateUserType', {
          'user_id': this.partnerLevel.user_id,
          'user_type': this.partnerLevel.user_type,
		  'desp':this.partnerLevel.desp
        }).then(response => {
          let data = response.data;
          if (data.code !== 0) {
            this.$Message.error(data.message);
            return false;
          } else {
            this.$Message.info('分销伙伴级别更新成功');
            this.showPartnerLevel = false;
            this.getUserList(this.page);
            return true;
          }
        }).catch(() => {
          this.$Message.error('网络错误');
        });
      },
    },
  }
  function formatterDate(date, pattern) {
    let ts = date.getTime()
    let d = new Date(ts).format('yyyy-MM-dd hh:mm:ss') // 默认日期时间格式 yyyy-MM-dd hh:mm:ss
    if (pattern) {
      d = new Date(ts).format(pattern)
    }
    return d.toLocaleString()
  }
  </script>